
export default {
  name: 'icon-dutyfree',
};
